/**
 * Sample React Native App
 * https://github.com/facebook/react-native
 *
 * @format
 * @flow
 */

import React, {Component} from 'react';

// import {
//   Header,
//   LearnMoreLinks,
//   Colors,
//   DebugInstructions,
//   ReloadInstructions,
// } from 'react-native/Libraries/NewAppScreen';

import {Platform, StyleSheet, Text, View, Image, TextInput, Button, TouchableOpacity} from 'react-native';
import {createAppContainer, NavigationActions } from 'react-navigation';
import {createStackNavigator} from 'react-navigation-stack'
import {createBottomTabNavigator} from 'react-navigation-tabs'
import { Icon, SocialIcon } from 'react-native-elements'
import Agenda from '../../web/src/Agenda'
import Agendado from '../../web/src/Agendado'
import Profile from '../../web/src/Profile'
// import { LoginButton, AccessToken, LoginManager } from 'react-native-fbsdk';
import {styles} from '../../web/src/Styles'

import firebase from 'firebase'
// GoogleSignin.configure();
import '../../web/src/firebase_app'

const colors = ["#dc812e"]
const logo_list_app = [
  require('../../web/img/construction.jpg'),
  require('../../web/img/construction.jpg'),
  // require('./img/stjoes.jpg')
  require('../../web/img/eleven_horizontal_white.jpeg'),
  require('../../web/img/eleven_horizontal_white.jpeg')
]

class TodoScreen extends React.Component {
  render() {
    return (
      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
        <Image
          source={require('../../web/img/construction.jpg')}
        />
      </View>
    );
  }
}

const TabNavigator = createBottomTabNavigator({
  Agenda: {
    screen: Agenda,
    navigationOptions: ({ navigation }) => ({
      // title: "Scores & Odds",
      tabBarIcon: ({ tintColor }) => <Icon name='clock-o' type='font-awesome'/>,
      tabBarOptions: {
        activeTintColor: colors[0]
      }
    })
  },
  Agendados: {
    screen: Agendado,
    navigationOptions: ({ navigation }) => ({
      // title: "Scores & Odds",
      tabBarIcon: ({ tintColor }) => <Icon name='book' type='font-awesome'/>,
      tabBarOptions: {
        activeTintColor: colors[0]
      }
    })
  },
  // Perfil: {
  //   screen: Profile,
  //   navigationOptions: ({ navigation }) => ({
  //       tabBarIcon: ({ tintColor }) => <Icon name='face'/>,
  //       tabBarOptions: {
  //         activeTintColor: colors[0]
  //       }
  //   })
  // }
});

// export interface MessagesIndex {
//     [index: string]: string;
// }
var error_list = new Proxy({}, {
  get: (target, name) => name in target ? target[name] : 'Erro: Verifique seu login.'
});
error_list['invalid-argument'] = 'Erro: Um argumento inválido foi fornecido.';
error_list['invalid-disabled-field'] = 'Erro: O valor fornecido para a propriedade de usuário é inválido.';
error_list['invalid-email'] = 'Erro: Email mal formatado.'
error_list['wrong-password'] = 'Erro: Senha incorreta.'
error_list['user-not-found'] = 'Erro: Usuário não encontrado.'
// const error_list = {
//         'invalid-argument': 'Erro: Um argumento inválido foi fornecido.',
//         'invalid-disabled-field': 'Erro: O valor fornecido para a propriedade de usuário é inválido.',
//         'invalid-email': 'Erro: Email mal formatado.'
//
//          /* ADD HERE THE OTHERs IDs AND THE CORRESPONDING MESSAGEs */
// };

class LoginScreen extends React.Component {
  state = { email: '', password: '', errorMessage: null, lastUser: null }

  constructor(props) {
    super(props)

    firebase.auth().onAuthStateChanged(user => {
      console.log("Login screen")
      console.log(user)
      // this.props.navigation.navigate(user ? 'Tab' : 'Signin')
      if (user) {
        this.state.lastUser = user;
        this.props.navigation.reset([NavigationActions.navigate({
          routeName: 'Tab',
        })], 0)
      } else if (!user && this.state.lastUser) {
        this.props.navigation.reset([NavigationActions.navigate({
          routeName: 'Login',
        })], 0)
      }
    })
  }
  handleLogin = () => {
    const { email, password } = this.state
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(() => this.props.navigation.reset([NavigationActions.navigate({
          routeName: 'Tab'
        })], 0))
      .catch(error => this.setState({ errorMessage: error_list[error.code.split('/')[1]]}))
  }

  // handleFacebookLogin () {
  //  LoginManager.logInWithPermissions(['public_profile', 'email']).then(
  //    function (result) {
  //      if (result.isCancelled) {
  //        console.log('Login cancelled')
  //      } else {
  //          AccessToken.getCurrentAccessToken().then(
  //            (data) => {
  //              const credential = firebase.auth.FacebookAuthProvider.credential(data.accessToken);
  //              firebase.auth().signInWithCredential(credential)
  //              .catch(error => alert(error.message))
  //              // alert(data.accessToken.toString())
  //            }
  //          )
  //      }
  //    },
  //    function (error) {
  //      console.log('Login fail with error: ' + error)
  //    }
  //  )
  // }
  handleFacebookLogin = () => {
    FB.login(function(response) {
        if (response.authResponse) {
         console.log('Welcome!  Fetching your information.... ');
         const credential = firebase.auth.FacebookAuthProvider.credential(response.authResponse.accessToken);
         firebase.auth().signInWithCredential(credential).catch(error => alert(error.message))

         // FB.api('/me', function(response) {
         //   console.log('Good to see you, ' + response.name + '.');
         // });
        } else {
         console.log('User cancelled login or did not fully authorize.');
        }
    });
  }


  // <LoginButton
  //   readPermissions={["email"]}
  //   onLoginFinished={
  //     (error, result) => {
  //       if (error) {
  //         alert("Login failed with error: " + error);
  //       } else if (result.isCancelled) {
  //         alert("Login was cancelled");
  //       } else {
  //         // alert("Login was successful with permissions: " + result.grantedPermissions)
  //         AccessToken.getCurrentAccessToken().then(
  //           (data) => {
  //             const credential = firebase.auth.FacebookAuthProvider.credential(data.accessToken);
  //             firebase.auth().signInWithCredential(credential)
  //             .catch(error => alert(error.message))
  //             // alert(data.accessToken.toString())
  //           }
  //         )
  //
  //
  //       }
  //     }
  //   }
  //   />

  render() {

    return (
      <View style={styles.loginContainer}>
        <Image
           source={logo_list_app[2]}
           style={styles.logoEleven}
        />
        {this.state.errorMessage &&
        <Text style={{ color: 'red' }}>
          {this.state.errorMessage}
        </Text>}
        <TextInput
         placeholder='Email'
         autoCapitalize="none"
         onChangeText={email => this.setState({ email })}
         value={this.state.email}
         style={styles.emailText}
        />
        <TextInput
          secureTextEntry
          placeholder="Senha"
          autoCapitalize="none"
          onChangeText={password => this.setState({ password })}
          value={this.state.password}
          style={styles.emailText}
        />
        <TouchableOpacity style={styles.emailButton} onPress={this.handleLogin}>
          <Text style={{color: 'white'}}>Entrar</Text>
        </TouchableOpacity>


        <TouchableOpacity onPress={() => this.props.navigation.navigate('Signup')} style={{flexDirection: 'row', marginTop: 5}}>
          <Text style={{textAlign: 'center'}}>Não possui conta? </Text>
          <Text style={{color: 'orange'}}>Registre aqui</Text>
        </TouchableOpacity>

        <TouchableOpacity onPress={() => this.props.navigation.navigate('Forgot')} style={{flexDirection: 'row', marginTop: 5}}>
          <Text style={{textAlign: 'center'}}>Esqueceu a sua senha? </Text>
          <Text style={{color: 'blue'}}>Resete aqui</Text>
        </TouchableOpacity>

        <Text style={{marginTop: 40}}>Ou faça login com o Facebook</Text>
        <SocialIcon button type='facebook' title='Entrar com o Facebook' style={styles.fbLogin}
          onPress={this.handleFacebookLogin}
        />
      </View>
    )

  }
}


class SignupScreen extends React.Component {
  state = { email: '', password: '', password_check: '', errorMessage: null }

  params = {
          'invalid-argument': 'Erro: Um argumento inválido foi fornecido.',
          'invalid-disabled-field': 'Erro: O valor fornecido para a propriedade de usuário é inválido.',

           /* ADD HERE THE OTHERs IDs AND THE CORRESPONDING MESSAGEs */

      };

  handleSignUp = () => {
    const { email, password, password_check } = this.state
    if (password != password_check) {
      this.setState({errorMessage: 'Senhas não batem'})
      return;
    }
    firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then(user => this.props.navigation.navigate('Tab'))
      .catch(error => this.setState({ errorMessage: error.message }))
  }

  render() {
    return (
      <View style={styles.loginContainer}>
        <Image
           source={logo_list_app[2]}
           style={styles.logoEleven}
        />
        {this.state.errorMessage &&
        <Text style={{ color: 'red' }}>
          {this.state.errorMessage}
        </Text>}
        <TextInput
         placeholder='Email'
         autoCapitalize="none"
         onChangeText={email => this.setState({ email })}
         value={this.state.email}
         style={styles.emailText}
        />
        <TextInput
          secureTextEntry
          placeholder="Senha"
          autoCapitalize="none"
          onChangeText={password => this.setState({ password })}
          value={this.state.password}
          style={styles.emailText}
        />
        <TextInput
          secureTextEntry
          placeholder="Repetir a senha"
          autoCapitalize="none"
          onChangeText={password_check => this.setState({ password_check })}
          value={this.state.password_check}
          style={styles.emailText}
        />
        <TouchableOpacity style={styles.emailButton} onPress={this.handleSignUp}>
          <Text style={{color: 'white'}}>Registrar</Text>
        </TouchableOpacity>
        <TouchableOpacity onPress={() => this.props.navigation.navigate('Login')} style={{flexDirection: 'row'}}>
          <Text style={{textAlign: 'center'}}>Já possui uma conta? </Text>
          <Text style={{color: 'orange'}}>Login</Text>
        </TouchableOpacity>
      </View>
    );
  }
}

class ForgotScreen extends React.Component {
  state = { email: '', errorMessage: null, loading: false }

  handleReset = () => {
    const { email } = this.state

    firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then(user => {this.props.navigation.navigate('Login'); alert('Um link para resetar seu password foi enviado para o seu email.')})
      .catch(error => this.setState({ errorMessage: error.message, loading: false }))
    this.setState({loading: true})
  }

  render() {
    const {loading} = this.state
    if (loading) {
      return (
        <View style={styles.loginContainer}>
          <Image
             source={logo_list_app[2]}
             style={styles.logoEleven}
          />
        </View>
      )
    }
    return (
      <View style={styles.loginContainer}>
        <Image
           source={logo_list_app[2]}
           style={styles.logoEleven}
        />
        {this.state.errorMessage &&
        <Text style={{ color: 'red' }}>
          {this.state.errorMessage}
        </Text>}
        <TextInput
         placeholder='Email'
         autoCapitalize="none"
         onChangeText={email => this.setState({ email })}
         value={this.state.email}
         style={styles.emailText}
        />
        <TouchableOpacity style={styles.emailButton} onPress={this.handleReset}>
          <Text style={{color: 'white'}}>Resetar</Text>
        </TouchableOpacity>
        <TouchableOpacity onPress={() => this.props.navigation.navigate('Login')} style={{flexDirection: 'row'}}>
          <Text style={{textAlign: 'center'}}>Lembrou da sua senha? </Text>
          <Text style={{color: 'orange'}}>Login</Text>
        </TouchableOpacity>
      </View>
    );
  }
}


const LoginNavigator = createStackNavigator({
  Login: {
    screen: LoginScreen
  },
  Forgot: {
    screen: ForgotScreen
  },
  // Signin: {
  //   screen: SigninScreen
  // },
  Signup: {
    screen: SignupScreen
  },
  Tab: {
    screen: TabNavigator
  }
},
{
  headerMode: 'none',
  navigationOptions: {
    headerVisible: false,
  }
 })

export default createAppContainer(LoginNavigator);
